// @ts-nocheck
import { Editor } from "@tinymce/tinymce-react";
import React, { useRef } from "react";
import { useFileSave } from "../../hooks/api/file/hooks";
import { TResponse } from "../../types/common";
import { IFile } from "../../types/api/file";

interface TinyMceProps {
  value?: string;
  onChange: (value: string) => void;
  disable?: boolean;
}

const TinyMce: React.FC<TinyMceProps> = ({
  value = "",
  onChange,
  disable = false,
}) => {
  const editorRef = useRef<any>(null); // editorRef can be typed as `Editor` if needed
  const fileMutation = useFileSave({});

  return (
    <Editor
      disabled={disable}
      tinymceScriptSrc="/tinymce.min.js"
      value={value}
      onInit={(evt: any, editor: any) => {
        editorRef.current = editor;
      }}
      init={{
        height: 500,
        menubar: false,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "anchor",
          "searchreplace",
          "visualblocks",
          "code",
          "fullscreen",
          "insertdatetime",
          "media",
          "table",
          "preview",
          "help",
          "wordcount",
          "autosave",
          "toc",
          "codesample",
          "emoticons",
          "quickbars",
        ],

        /* ✅ toolbar only once */
        toolbar:
          "undo redo | toc | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor casechange removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | showcomments addcomment",

        menubar: "file edit view insert format tools table help",

        /* ✅ content_style MUST be string */
        content_style: `
          @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
          body {
            font-family: Montserrat, Helvetica, Arial, sans-serif;
            font-size: 14px;
          }
          .mymention { color: gray; }
        `,

        autosave_ask_before_unload: true,
        autosave_interval: "30s",
        autosave_retention: "2m",

        image_advtab: true,
        image_caption: true,

        quickbars_selection_toolbar:
          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",

        noneditable_noneditable_class: "mceNonEditable",
        toolbar_mode: "sliding",

        font_formats:
          "Montserrat=Montserrat; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",

        contextmenu: "link image imagetools table configurepermanentpen",
        file_picker_callback: function (cb, value, meta) {
          const input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", "image/*");
          input.onchange = function () {
            const file = this.files[0];
            const fmData = new FormData();
            fmData.append("file", file);
            try {
              fileMutation.mutate(fmData, {
                onSuccess: (res) => {
                  cb(res.data.url, { title: res.data.name });
                },
                onError: (err) => {},
              });
            } catch (err) {}
          };
          input.click();
        },
      }}
      onSelectionChange={() => {
        if (editorRef.current) {
          onChange(editorRef.current.getContent());
        }
      }}
    />
  );
};

export default TinyMce;
